import React from 'react'
import { Box } from '../Base'

export const FormElementGlobalError = React.memo(
  ({ globalError }) =>
    globalError && (
      <Box
        color="negative"
        mb={20}
        border="1px solid"
        borderColor="negative"
        display="inline-block"
        borderRadius={5}
        px={10}
        py="5px"
      >
        {globalError}
      </Box>
    )
)

export const FormElementSubmitButton = React.memo(
  ({ disabled, children = 'Suivant', fixOnXs = true }) => (
    <Box
      display="flex"
      justifyContent="flex-end"
      mt={30}
      position={{ md: 'inherit', xs: fixOnXs ? 'fixed' : undefined }}
      bottom={{ md: 'inherit', xs: 0 }}
      mx={{ md: 'inherit', xs: fixOnXs ? '-20px' : undefined }}
      left={0}
      right={0}
      zIndex="2"
    >
      <Box
        as="button"
        className="btn is-tertiary is-medium"
        disabled={disabled}
        type="submit"
        width={{ md: 'auto', xs: fixOnXs ? 1 : undefined }}
        borderRadius={{ md: 5, xs: fixOnXs ? 0 : undefined }}
      >
        {children}
      </Box>
    </Box>
  )
)
